import { useState } from "react";
import { Form, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useMutateData } from "../../hooks/useMutateData";

const ChangePassword = ({ isAdmin=false }) => {
  const [confirmPassword, setConfirmPassword] = useState();
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordConfirm, setShowPasswordConfirm] = useState(false);
  const [showError, setShowError] = useState(false);
  const [isValidPassword, setIsValidPassword] = useState(false);
  const [showPasswordError, setShowPasswordError] = useState(false);
  const [newUserCredentials, setNewUserCredentials] = useState({});
  const user = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setNewUserCredentials((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const { mutate, isSuccess } = useMutateData();
  const changePassword = async (e) => {
    e.preventDefault();
    const dataToSend = {
      newPassword: newUserCredentials.newPassword,
      username: user?.username,
    }
    const postUrl = `users/changepassword`;
    const successMessage = "Password changed successfully";
    try {
      if (newUserCredentials.newPassword !== confirmPassword) {
        setShowError(true);
      } else {
        await mutate({
          url: postUrl,
          payload: isAdmin ? newUserCredentials: dataToSend,
          successMessage,
          method: "POST",
        });
      }
    } catch (error) {
      console.log(error);
    }
  };
  if (isSuccess) navigate("/");
  return (
    <>
      <div className='card-header d-flex justify-content-center custom-btn-color'>
        <h3 style={{ color: "#FFF", fontWeight: 600 }}>
          {isAdmin ? "Change User Password" : "Change Your Password"}
        </h3>
      </div>
      <div
        className='d-flex
        justify-content-center mt-3'
      >
        <Form onSubmit={changePassword} className='change-password-container'>
          {isAdmin && (
            <>
              <label className='ml-2'>Username</label>
              <input
                name='username'
                placeholder='Type username'
                className='form-control input-select mb-2'
                onChange={handleInputChange}
                required
              />
            </>
          )}
          {/* {!isAdmin && (
            <>
              <label className='ml-2'>Current password</label>
              <input
                name='currentPassword'
                type="password"
                placeholder='Your current password'
                className='form-control input-select mb-2'
                onChange={handleInputChange}
                required
              />
            </>
          )} */}
          <label className='ml-2'>New password</label>
          <div style={{ position: "relative" }}>
            <input
              placeholder='New password'
              name='newPassword'
              type={showPassword ? "text" : "password"}
              className='form-control input-select mb-2'
              onChange={(e) => {
                setNewUserCredentials({
                  ...newUserCredentials,
                  newPassword: e.target.value,
                });
                const isValidPassword =
                  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@#$%^&+=!])[a-zA-Z\d@#$%^&+=!]{8,}$/.test(
                    e.target.value
                  );
                setIsValidPassword(isValidPassword);
                if (isValidPassword) {
                  setShowPasswordError(false);
                } else {
                  setShowPasswordError(true);
                }
              }}
              onKeyUp={() => setShowError(false)}
              required
            />
            {newUserCredentials?.newPassword?.length > 0 && (
              <i
                className='fa fa-eye'
                aria-hidden='true'
                style={{
                  position: "absolute",
                  right: 15,
                  bottom: 8,
                  cursor: "pointer",
                  fontSize: 20,
                  color: "#0000ff",
                }}
                onClick={() => setShowPassword(!showPassword)}
              />
            )}
          </div>
          {!isValidPassword &&
            showPasswordError &&
            newUserCredentials?.newPassword?.length > 0 && (
              <>
                <span style={{ color: "#8f250d" }}>
                  * Password should be at least 8 characters long
                </span>
                <br />
                <span style={{ color: "#8f250d" }}>
                  * Mix of letters and numbers
                </span>
                <br />
                <span style={{ color: "#8f250d" }}>
                  * Upper case and lower case
                </span>
                <br />
                <span style={{ color: "#8f250d" }}>* Special character</span>
              </>
            )}
          <div style={{ position: "relative" }}>
            <label className='ml-2'>Confirm Password</label>
            <input
              placeholder='Confirm Password'
              type={showPasswordConfirm ? "text" : "password"}
              className='form-control input-select mb-2'
              onChange={(e) => setConfirmPassword(e.target.value)}
              onKeyUp={() => setShowError(false)}
              required
            />
            {showError && (
              <span style={{ color: "red" }}>Password not Match</span>
            )}
            {confirmPassword?.length > 0 && (
              <i
                className='fa fa-eye'
                aria-hidden='true'
                style={{
                  position: "absolute",
                  right: 15,
                  bottom: 8,
                  cursor: "pointer",
                  fontSize: 20,
                  color: "#0000ff",
                }}
                onClick={() => setShowPasswordConfirm(!showPasswordConfirm)}
              />
            )}
          </div>
          <Button
            type='submit'
            className='mt-4 d-block custom-btn-color'
            style={{ marginLeft: "20%", marginRight: "30%", width: "65%" }}
            disabled={!isValidPassword}
          >
            Change Password
          </Button>
        </Form>
      </div>
    </>
  );
};

export default ChangePassword;
